const galleries = [
  '.pradesto-about-gallery',
  '.pradesto-proj-real',
  '.pradesto-proj-viz',
  '.pradesto-inw-measure__gallery',
  '.pradesto-inw-doc__grid',
  '.pradesto-inw-diag__grid',
];

const gallerySelector = galleries.map((selector) => `${selector} img`).join(',');
let currentImages = [];
let currentIndex = 0;
let lastTrigger = null;

const lightbox = document.createElement('div');
lightbox.className = 'pradesto-lightbox';
lightbox.setAttribute('role', 'dialog');
lightbox.setAttribute('aria-modal', 'true');
lightbox.setAttribute('aria-label', 'Galeria zdjęć');
lightbox.hidden = true;
lightbox.innerHTML = `
  <button class="pradesto-lightbox__close" type="button" aria-label="Zamknij podgląd">&times;</button>
  <button class="pradesto-lightbox__arrow pradesto-lightbox__arrow--prev" type="button" aria-label="Poprzednie zdjęcie">&#8249;</button>
  <div class="pradesto-lightbox__stage">
    <img class="pradesto-lightbox__image" alt="">
  </div>
  <button class="pradesto-lightbox__arrow pradesto-lightbox__arrow--next" type="button" aria-label="Następne zdjęcie">&#8250;</button>
  <div class="pradesto-lightbox__thumbs" aria-label="Miniatury zdjęć"></div>
`;
document.body.append(lightbox);

const image = lightbox.querySelector('.pradesto-lightbox__image');
const closeButton = lightbox.querySelector('.pradesto-lightbox__close');
const prevButton = lightbox.querySelector('.pradesto-lightbox__arrow--prev');
const nextButton = lightbox.querySelector('.pradesto-lightbox__arrow--next');
const thumbs = lightbox.querySelector('.pradesto-lightbox__thumbs');

function showImage(index) {
  currentIndex = (index + currentImages.length) % currentImages.length;
  const item = currentImages[currentIndex];
  image.src = item.currentSrc || item.src;
  image.alt = item.alt || '';

  thumbs.querySelectorAll('button').forEach((button, buttonIndex) => {
    const active = buttonIndex === currentIndex;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-current', active ? 'true' : 'false');
    if (active) button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
}

function buildThumbnails() {
  thumbs.replaceChildren(...currentImages.map((item, index) => {
    const button = document.createElement('button');
    const thumb = document.createElement('img');
    button.type = 'button';
    button.className = 'pradesto-lightbox__thumb';
    button.setAttribute('aria-label', `Pokaż zdjęcie ${index + 1}`);
    thumb.src = item.currentSrc || item.src;
    thumb.alt = '';
    button.append(thumb);
    button.addEventListener('click', () => showImage(index));
    return button;
  }));
}

function closeLightbox() {
  lightbox.hidden = true;
  document.body.classList.remove('pradesto-lightbox-open');
  image.removeAttribute('src');
  lastTrigger?.focus();
}

function openLightbox(trigger) {
  lastTrigger = trigger;
  const container = galleries.map((selector) => trigger.closest(selector)).find(Boolean);
  currentImages = [...container.querySelectorAll('img')];
  currentIndex = currentImages.indexOf(trigger);
  buildThumbnails();
  showImage(currentIndex);
  lightbox.hidden = false;
  document.body.classList.add('pradesto-lightbox-open');
  lightbox.classList.toggle('has-single-image', currentImages.length < 2);
  closeButton.focus();
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest(gallerySelector);
  if (trigger) return openLightbox(trigger);
  if (event.target === lightbox || event.target === closeButton) closeLightbox();
  if (event.target === prevButton) showImage(currentIndex - 1);
  if (event.target === nextButton) showImage(currentIndex + 1);
});

document.addEventListener('keydown', (event) => {
  if (lightbox.hidden) return;
  if (event.key === 'Escape') closeLightbox();
  if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
  if (event.key === 'ArrowRight') showImage(currentIndex + 1);
});

document.querySelectorAll(gallerySelector).forEach((item) => {
  item.tabIndex = 0;
  item.setAttribute('role', 'button');
  item.setAttribute('aria-label', `${item.alt || 'Zdjęcie'} — otwórz galerię`);
  item.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openLightbox(item);
    }
  });
});
